export const SCHOOL_LIST_LEFT = [
  {
    key: 'DBN',
    value: ({ SHELTER_SCHOOL_DBN }) => SHELTER_SCHOOL_DBN,
  },
  {
    key: 'Phone',
    value: ({ SCHOOL_PHONE }) => SCHOOL_PHONE,
  },
  {
    key: 'School Admit Date',
    value: ({ ADMIT_DATE }) => (ADMIT_DATE ? moment(ADMIT_DATE).format('MMM DD YYYY') : null),
  },
  {
    key: 'Class/Grade',
    value: ({ CLASS, SHELTER_GRADE }) => {
      const klass = CLASS;
      const grade = SHELTER_GRADE ? (!Number.isNaN(+SHELTER_GRADE) ? getOrdinal(+SHELTER_GRADE) : SHELTER_GRADE) : null;
      if (klass && !grade) return klass;
      if (grade && !klass) return grade;
      if (klass && grade) return `${klass} (${grade} grade)`;
      return null;
    },
  },
];

export const SCHOOL_LIST_RIGHT = [
  {
    key: 'SWD',
    value: ({ IS_SPED }) => {
      if (IS_SPED) return 'Yes';
      else if (IS_SPED === false) return 'No';
      else return null;
    },
  },
  {
    key: 'MLL',
    value: ({ IS_ELL }) => {
      if (IS_ELL) return 'Yes';
      else if (IS_ELL === false) return 'No';
      else return null;
    },
  },
  {
    key: 'Transit',
    value: ({ TRANSIT_TIME, TRANSIT_DISTANCE }) => {
      let timeText: string = '';
      let distanceText: string = '';

      if (TRANSIT_TIME === null && TRANSIT_DISTANCE === null) return null;

      if (TRANSIT_TIME !== null) {
        const hoursInMinutes = Math.floor(TRANSIT_TIME / 60);
        const hoursText = hoursInMinutes ? `${hoursInMinutes}h` : '';
        const remainingMinutes = TRANSIT_TIME % 60;
        const minutesText = remainingMinutes > 1 || remainingMinutes === 0 ? 'mins' : 'min';
        timeText = `${hoursText} ${remainingMinutes} ${minutesText}`;
      }

      if (TRANSIT_DISTANCE !== null) {
        const milesText = TRANSIT_DISTANCE > 1 || TRANSIT_DISTANCE === 0 ? 'miles' : 'mile';
        distanceText =
          TRANSIT_TIME !== null ? `(${TRANSIT_DISTANCE} ${milesText})` : `${TRANSIT_DISTANCE} ${milesText}`;
      }

      return `${timeText} ${distanceText}`;
    },
  },
];

export const SHELTER_LIST_LEFT = [
  {
    key: 'Shelter Unit',
    value: ({ SHELTER_UNIT }) => SHELTER_UNIT,
  },
  {
    key: 'Admit Date',
    value: ({ SHELTER_ADMIT_DATE }) => moment(SHELTER_ADMIT_DATE).format('MMM DD YYYY'),
  },
  {
    key: 'Application',
    value: ({ SHELTER_ELIGIBILITY_OUTCOME }) => SHELTER_ELIGIBILITY_OUTCOME,
  },
  {
    key: 'Family ID',
    value: ({ CARES_FAMILY_ID }) => CARES_FAMILY_ID,
  },
];

export const SHELTER_LIST_RIGHT = [
  {
    key: 'Housing Status',
    value: ({ HOUSING_STATUS }) => (HOUSING_STATUS ? HOUSING_STATUS : null),
  },
  {
    key: 'Temporary Housing',
    value: ({ TEMP_HOUSING_FLAG }) => {
      if (TEMP_HOUSING_FLAG) return 'Yes';
      else if (TEMP_HOUSING_FLAG === false) return 'No';
      else return null;
    },
  },
  {
    key: 'Prev. Address',
    value: ({ HOME_ADDRESS_PREVIOUS_TO_SHELTER }) => HOME_ADDRESS_PREVIOUS_TO_SHELTER,
  },
];

export const PRINCIPAL_CONTACT_CONFIG = {
  title: 'Principal',
  namePath: 'SCHOOL_PRINCIPAL_NAME',
  emailPath: 'SCHOOL_PRINCIPAL_EMAIL',
  tooltip: 'Copy email address',
};

export const BASIC_INFO_PROJECTION = [
  'SCHOOL_DBN',
  'SCHOOL_NAME',
  'SCHOOL_PHONE',
  'ADMIT_DATE',
  'CLASS',
  'SHELTER_GRADE',
  'IS_SPED',
  'IS_ELL',
  'TRANSIT_TIME',
  'TRANSIT_DISTANCE',
  'SCHOOL_PRINCIPAL_NAME',
  'SCHOOL_PRINCIPAL_EMAIL',
  'SHELTER_UNIT',
  'SHELTER_ADMIT_DATE',
  'SHELTER_ELIGIBILITY_OUTCOME',
  'CARES_FAMILY_ID',
  'HOUSING_STATUS',
  'TEMP_HOUSING_FLAG',
  'HOME_ADDRESS_PREVIOUS_TO_SHELTER',
];

function ordinalIndicator(n: number): string {
  const num = Math.abs(n);
  const cent = num % 100;
  if (cent >= 10 && cent <= 20) return 'th';
  const dec = num % 10;
  if (dec === 1) return 'st';
  if (dec === 2) return 'nd';
  if (dec === 3) return 'rd';
  return 'th';
}

function getOrdinal(n: number): string {
  return `${n}${ordinalIndicator(n)}`;
}
